// extracted by mini-css-extract-plugin
module.exports = {"container":"A_BasicExample_container_j5BTr"};